import React, { useEffect } from "react";
import { Modal, Form, Input, Button, Radio } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { DataType } from "./ListUser";

interface IProps {
  isShowCreate: boolean;
  onCancel: () => void;
  onRefesh: () => void;
  isShowEdit: boolean;
  onCanEdit: () => void;
  data?: DataType;
}

interface IForm {
  username: string;
  phone: string;
  password: string;
  re_password: string;
  role: string;
}

const ModalUser: React.FC<IProps> = ({
  isShowCreate,
  onCancel,
  onRefesh,
  onCanEdit,
  isShowEdit,
  data,
}) => {
  const Cookie = require("js-cookie");
  const token = Cookie.get("access_token");
  const [form] = Form.useForm();

  useEffect(() => {
    if (isShowEdit && data) {
      form.setFieldsValue({
        username: data?.username,
        phone: data?.phone,
      });
    } else {
      form.resetFields();
    }
  }, [isShowEdit, data, form]);

  const userInfoRaw = localStorage.getItem("user_info");
  const userInfo = userInfoRaw ? JSON.parse(userInfoRaw) : null;
  const isSuperAdmin = userInfo?.role === "SUPERADMIN";

  const handleCreate = async (value: IForm) => {
    if (value.password !== value.re_password) {
      Swal.fire({
        icon: "error",
        title: "Mật khẩu không trùng khớp",
        text: "Vui lòng kiểm tra lại mật khẩu.",
      });
      return;
    }

    try {
      const payload: Record<string, string> = {
        username: value.username,
        password: value.password,
        phone: value.phone,
      };

      if (isSuperAdmin) {
        payload.role = value.role === "r_admin" ? "ADMIN" : "USER";
      }

      const response = await axios.post(
        `${process.env.REACT_APP_URL_API}/users`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            accept: "*/*",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        onCancel();
        Swal.fire({
          icon: "success",
          title: "Tạo tài khoản thành công",
          timer: 1000,
          timerProgressBar: true,
          customClass: {
            popup: "custom-swal",
            title: "custom-title",
          },
        });
        onRefesh();
      }
    } catch (err: any) {
      Swal.fire({
        icon: "error",
        title: "Lỗi tạo tài khoản",
        text: err?.response?.data?.message || "Có lỗi xảy ra, vui lòng thử lại.",
      });
    }
  };

  const handleEdit = async (value: IForm) => {
    try {
      const payload: Record<string, string> = {
        username: value.username,
        phone: value.phone,
      };

      if (value.password) {
        payload.password = value.password;
      }

      const response = await axios.put(
        `${process.env.REACT_APP_URL_API}/users/${String(data?._id)}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            accept: "*/*",
          },
        }
      );

      if (response.status === 200) {
        onCanEdit();
        Swal.fire({
          icon: "success",
          title: "Cập nhật tài khoản thành công",
          timer: 1000,
          timerProgressBar: true,
          customClass: {
            popup: "custom-swal",
            title: "custom-title",
          },
        });
        onRefesh();
      }
    } catch (err: any) {
      Swal.fire({
        icon: "error",
        title: "Lỗi cập nhật",
        text: err?.response?.data?.message || "Có lỗi xảy ra, vui lòng thử lại.",
      });
    }
  };

  return (
    <Modal
      title={isShowEdit ? "Edit User" : "Create User"}
      open={isShowCreate || isShowEdit}
      onCancel={() => {
        onCanEdit();
        onCancel();
      }}
      footer={null}
    >
      <Form
        onFinish={isShowCreate ? handleCreate : handleEdit}
        form={form}
        initialValues={{ role: "r_user" }}
      >
        <Form.Item
          label="UserName"
          name="username"
          labelCol={{ span: 24 }}
          rules={[{ required: true, message: "Please input your UserName!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="SDT"
          name="phone"
          labelCol={{ span: 24 }}
          rules={[{ required: true, message: "Please input your Phone!" }]}
        >
          <Input maxLength={10} />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          labelCol={{ span: 24 }}
          rules={
            isShowCreate
              ? [{ required: true, message: "Please input your Password!" }]
              : undefined
          }
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label="Nhập lại password"
          name="re_password"
          labelCol={{ span: 24 }}
          rules={
            isShowCreate
              ? [{ required: true, message: "Please input your Re-Password!" }]
              : undefined
          }
        >
          <Input.Password />
        </Form.Item>

        {isShowCreate && isSuperAdmin && (
          <Form.Item label="Quyền Hạn" name="role">
            <Radio.Group>
              <Radio value="r_admin">Admin</Radio>
              <Radio value="r_user">User</Radio>
            </Radio.Group>
          </Form.Item>
        )}

        <div className="flex justify-end gap-3">
          <Button className="bg-green-500 text-white" htmlType="submit">
            Lưu
          </Button>
          <Button
            onClick={() => {
              onCanEdit();
              onCancel();
            }}
          >
            Đóng
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalUser;
